import { ToastContainer } from 'react-toastify';
import ConfigProvider from './ConfigProvider.tsx';
import ContextProvider from './ContextProvider.tsx';
import Footer from './footer/Footer';
import Header from './header/Header';
import { StoreProvider } from '../lib/context/StoreProvider';
import { Outlet } from 'react-router';

export default function RootLayout() {
    return (
      <StoreProvider>
          <div className="flex flex-col h-screen overflow-hidden">
              <ConfigProvider>
                  <ContextProvider>
                      <Header/>
                      <ToastContainer
                          autoClose={8000}
                          pauseOnHover={true}
                          pauseOnFocusLoss={true}

                      />
                      <div className="flex flex-col flex-1 overflow-auto">
                              <div id="body"
                                   className="max-w-screen-xl w-full mx-auto flex flex-col flex-1 lg:my-8 px-4">
                                  <Outlet />
                              </div>
                          <Footer/>
                      </div>
                  </ContextProvider>
              </ConfigProvider>
          </div>
      </StoreProvider>
    );
}
